import React, { useState } from 'react';
import { Box, Flex, Image } from '@chakra-ui/react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { CheckIcon } from '@chakra-ui/icons';
import { EditUserNick } from './editUserNick';
import { EditSocials } from './editSocials';
import { InfoPane } from './infoPane';
import { t } from 'i18next';
import { useUserProvider } from '../../../providers/User/userProvider';
import { useUserEditorProvider } from '../../../providers/UserEditor/userEditorProvider';
import { SocialsPane } from '../../../common/components/socialsPane';
import { trimAddress } from '../../../utils/parser';
import { Color } from 'src/theme/color';
import { ThumbsUpIcon } from '../../../common/components/icons/thumbs_up';
import { LinkGrayIcon } from '../../../common/components/icons/link_gray';

interface IMainUser {
	account: string;
	balance: string;
	isOwner: boolean;
	nativeBalance: string;
	USDCBalance: string;
}

export const MainUserInfo = ({ account, balance, isOwner, nativeBalance, USDCBalance }: IMainUser) => {
	const { data } = useUserProvider();
	const editorData = useUserEditorProvider();

	const [nick, setNick] = useState(editorData.nickname ?? (data.nickname || 'Unnamed User'));

	return (
		<Flex
			justifyContent="space-between"
			flexDirection="column"
			zIndex={5}
		>
			<Flex
				flexDirection="column"
				gridGap="4px"
			>
				<Flex alignItems="center">
					<EditUserNick
						nickname={nick}
						isOwner={isOwner}
						onNickChange={v => setNick(v)}
					/>

					{data.verified && (
						<Flex
							ml="10px"
							w="17px"
							h="17px"
							justifyContent="center"
							alignItems="center"
							bg={editorData.color ?? data.color ?? Color.ACTION}
							borderRadius="50%"
						>
							<CheckIcon fontSize="11px" />
						</Flex>
					)}
				</Flex>
				<Flex
					fontSize={{ base: '10px', hashup: '14px' }}
					color={Color.BACKGROUND_TERTIARY}
					alignItems="center"
				>
					{trimAddress(account)}
					<Flex
						ml="5px"
						maxW="14px"
						maxH="14px"
					>
						<CopyToClipboard text={account}>
							<Box
								cursor="pointer"
								height={{ base: '10px', hashup: 'unset' }}
							>
								<LinkGrayIcon />
							</Box>
						</CopyToClipboard>
					</Flex>
				</Flex>
			</Flex>

			<Box display={{ base: 'none', hashup: 'block' }}>
				<InfoPane
					topic={t('team.hashInWallet').toString()}
					content={balance}
					isMonetary
					subTopic={nativeBalance}
					USDCBalance={USDCBalance}
				/>
			</Box>

			<Flex gridGap="8px">
				<SocialsPane
					socials={data.socials}
					colors={data.color}
				/>
				{isOwner && <EditSocials />}
			</Flex>
		</Flex>
	);
};
